<div class="fls-1-1">
  <main>
    <div class="fls-1-1 ds-fl jc-ctr mwb-6">
      <img
        src="{{ cdnHost }}/img/question-quackals.svg"
        alt="question-quackals"
        class="question-quackals"
      />
    </div>

    <p>
      {{ message }}
    </p>

    <p>If this problem continues, please call Customer Care at</p>

    <p>
      <a href="tel:1{{ supportNumber }}">{{ supportNumber | phone }}</a>
    </p>
    <p>
      or email
      <a
        href="mailto:{{ supportEmail }}?subject=I'm having trouble with myQQ!"
        >{{ supportEmail }}</a
      >
    </p>

    <p>for assistance in finishing the sign-up process.</p>
  </main>

  <footer>
    <button
      myqq-button
      (click)="startOver()"
      (keydown.enter)="$event.preventDefault()"
      (keyup.enter)="startOver()"
      aria-label="Try again"
      class="raised large"
      color="primary"
    >
      {{ buttonText }}
    </button>
  </footer>
</div>
